import { render, staticRenderFns } from "./ModuleNew.vue?vue&type=template&id=5907c0ca&"
import script from "./ModuleNew.vue?vue&type=script&lang=ts&"
export * from "./ModuleNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5907c0ca')) {
      api.createRecord('5907c0ca', component.options)
    } else {
      api.reload('5907c0ca', component.options)
    }
    module.hot.accept("./ModuleNew.vue?vue&type=template&id=5907c0ca&", function () {
      api.rerender('5907c0ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ModuleNew.vue"
export default component.exports